import {
  BarChartIcon,
  DatabaseIcon,
  GlobeIcon,
  SettingsIcon,
  TrendingUpIcon,
  UsersIcon,
} from "lucide-react";
import { getSeq } from "../../../../../helpers/get-seq";
import { Card, CardContent } from "../../../utils/landing-page/card";
import "./index.scss";

export function FonctionaliteSection() {
  const topRowFeatures = [
    {
      title: "Tableau de bord unifié",
      icon: <BarChartIcon className="FonctionaliteSection-icon" />,
      description:
        "Interface centralisée pour visualiser les données de toutes les structures sous tutelle avec des métriques en temps réel.",
      borderClass: "greenBorder",
      iconGradient: "greenGradient",
    },
    {
      title: "Gestion des référentiels",
      icon: <DatabaseIcon className="FonctionaliteSection-icon" />,
      description:
        "Création et administration de référentiels avec des structures de donnée complexes, import en masse et synchronisation via des services tiers.",
      borderClass: "greenBorder",
      iconGradient: "greenGradient",
    },
    {
      title: "Gestion des structures",
      icon: <UsersIcon className="FonctionaliteSection-icon" />,
      description:
        "Administration centralisée des entités gouvernementales, leurs responsables, statuts et niveau de validation.",
      borderClass: "greenBorder",
      iconGradient: "greenGradient",
    },
  ];

  const bottomRowFeatures = [
    {
      title: "Performance optimisée",
      icon: <TrendingUpIcon className="FonctionaliteSection-icon" />,
      description:
        "Architecture haute performance avec temps de réponse rapides et capacité de traitement de plusieurs enregistrements.",
      borderClass: "blueBorder",
      iconGradient: "blueGradient",
    },
    {
      title: "Configuration flexible",
      icon: <SettingsIcon className="FonctionaliteSection-icon" />,
      description:
        "Paramétrage avancé adapté aux spécificités de chaque structure avec des KPI personnalisables.",
      borderClass: "blueBorder",
      iconGradient: "blueGradient",
    },
    {
      title: "Journalisation complète",
      icon: <GlobeIcon className="FonctionaliteSection-icon" />,
      description:
        "Traçabilité exhaustive de toutes les actions avec dans un journal détaillé.",
      borderClass: "blueBorder",
      iconGradient: "blueGradient",
    },
  ];

  return (
    <section id="fonctionalite" className="FonctionaliteSection">
      <div className="FonctionaliteSection-container">
        <div className="FonctionaliteSection-header">
          <h2 className="FonctionaliteSection-title">
            Fonctionnalités de la Plateforme
          </h2>
          <p className="FonctionaliteSection-description">
            Une suite complète d'outils conçus spécifiquement pour répondre aux besoins des
            structures administratives béninoises et optimiser la gouvernance des données.
          </p>
        </div>
      </div>

      <div className="FonctionaliteSection-content">
        <div className="FonctionaliteSection-grid">
          {topRowFeatures.map((feature, index) => (
            <div
              key={`landingpage-top-feature--${getSeq()}-${index}`}
              className={`FonctionaliteSection-featureCard ${feature.borderClass}`}
            >
              <Card className="FonctionaliteSection-card">
                <CardContent className="FonctionaliteSection-cardContent">
                  <div className="FonctionaliteSection-cardInner">
                    <div className="FonctionaliteSection-featureHeader">
                      <div className={`FonctionaliteSection-iconContainer ${feature.iconGradient}`}>
                        {feature.icon}
                      </div>
                      <h3 className="FonctionaliteSection-featureTitle">
                        {feature.title}
                      </h3>
                    </div>
                    <p className="FonctionaliteSection-featureDescription">
                      {feature.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        <div className="FonctionaliteSection-grid">
          {bottomRowFeatures.map((feature, index) => (
            <div
              key={`landingpage-bottom-feature--${getSeq()}-${index}`}
              className={`FonctionaliteSection-featureCard ${feature.borderClass}`}
            >
              <Card className="FonctionaliteSection-card">
                <CardContent className="FonctionaliteSection-cardContent">
                  <div className="FonctionaliteSection-cardInner">
                    <div className="FonctionaliteSection-featureHeader">
                      <div className={`FonctionaliteSection-iconContainer ${feature.iconGradient}`}>
                        {feature.icon}
                      </div>
                      <h3 className="FonctionaliteSection-featureTitle">
                        {feature.title}
                      </h3>
                    </div>
                    <p className="FonctionaliteSection-featureDescription">
                      {feature.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
